import Reflux from 'reflux';
import AppActions from './AppActions';
import ModalActions from './actions/ModalActions';
import SearchActions from './actions/SearchActions';
import axios from 'axios';
import * as Utilities from './Utilities';
import history from './history';
import base64 from 'base-64';
export default class AppStore extends Reflux.Store {
    constructor () {
        super();
        let decodedToken = false;
        let userData = JSON.parse(window.localStorage.getItem('user')) || {};
        if (userData && userData.token) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + userData.token;
            let parts = userData.token.split('.');
            decodedToken = JSON.parse(base64.decode(parts[1]));
        }
        if (!userData.profile_image) {
            userData.profile_image = {};
        }
        this.state = {
            currentTopic: {
                options: []
            },
            creatorOptions: [],
            optionIndex: 0,
            title: '',
            page: 0,
            comments: [],
            currentCountry: 'AR',
            comment: '',
            currentTopicCreatorImage: '../images/icons/default.jpg',
            topicActivity: {
            },
            options: [{position: 1}, {position: 2}, {position: 3}, {position: 4}, {position: 5}],
            trendingTopics: [],
            latestTopics: [],
            autogeneratedTopics: [],
            relatedTopics: [],
            randomSentences: [],
            apiUrl: process.env.REACT_APP_API_URL + '/api',
            userLogged: userData.logged || false,
            userData: userData,
            user: decodedToken,
            autocompletedString: '',
            redirectTo: false,
            pageLimit: 6,
            otherOptions: [],
            otherOptionsCopy: [],
            topicLikes: 0,
            topicDislikes: 0,
            topicDislikedByUser: false,
            enableEditing: false,
            topicLikedByUser: false,
            cantFavs: 0,
            loadingOptions: false,
            loadingComments: true,
            loadingTopicInformation: true,
            loadingTrendingTopics: true,
            loadingLatestTopics: true,
            loadingLogin: false,
            commentsLimit: 4,
            loadMoreComments: false,
            isUserFollowed: false,
            isSameTopicByMe: false,
            sameTopicByMe: {},
            popularUsers: [],
            followedTopics: [],
            unreadedNotifications: [],
            uploadingTopic: false
        };
        this.listenables = AppActions;
        if (userData.name && !userData.username) {
            AppActions.updateUserProfile();
        }
        AppActions.getUnreadedNotifications();
    }
    onGetLatestTopics (page) {
        let skip = 0;
        if (page) {
            skip = (page - 1) * this.state.pageLimit;
        }
        this.setState({loadingLatestTopics: true});
        return axios.get(this.state.apiUrl + '/usertopics?populate=createdBy&sort=-updatedAt&select=-comments&limit=' + this.state.pageLimit + '&skip=' + skip)
          .then((results) => {
              this.setState({latestTopics: results.data, loadingLatestTopics: false});
          });
    }
    onGetMoreLatestTopics (newPage) {
        let skip = (newPage - 1) * this.state.pageLimit;
        let pageLimit = this.state.pageLimit;
        if (newPage === 1 || newPage < this.state.page) {
            skip = 0;
            pageLimit = newPage * pageLimit;
        }
        this.setState({page: newPage});
        return axios.get(this.state.apiUrl + '/usertopics?populate=createdBy&sort=-updatedAt&select=-comments&limit=' + pageLimit + '&skip=' + skip)
          .then((results) => {
              let latestTopics = skip !== 0 ? this.state.latestTopics.concat(results.data) : results.data;
              this.setState({latestTopics: latestTopics});
          });
    }
    onGetTrendingTopics () {
        this.setState({loadingTrendingTopics: true});
        return axios.get(this.state.apiUrl + '/topics?conditions={"type":"top5"}&limit=3')
          .then((topics) => {
              const cantTopics = topics.data.length;
              if (cantTopics === 3) {
                  return topics.data;
              }
              const limit = (3 - topics.data.length);
              const idTopics = topics.data.map((topic) => { return topic._id; });
              const conditions = {
                  $and: [
                      {_id: { $nin: idTopics }},
                      {type: 'popular-AR'}
                  ]
              };
              return axios.get(this.state.apiUrl + `/topics?conditions=${JSON.stringify(conditions)}&limit=${limit}`)
                  .then((results) => {
                      return topics.data.concat(results.data);
                  });
          })
        .then((results) => {
            let popularsTitles = results.map(popular => popular.topic);
            let popularRequests = popularsTitles.map((title) => {
                return axios.get(`${this.state.apiUrl}/globaltopics?conditions={"title":"${title}"}&limit=1&sort=-updatedAt`)
                .then((response) => {
                    if (response.data.length === 0) {
                        return;
                    }
                    return response.data[0];
                });
            });
            return Promise.all(popularRequests);
        })
          .then((results) => {
              return results.filter((item) => item);
          })
          .then((results) => {
              this.setState({trendingTopics: results, loadingTrendingTopics: false});
          });
    }
    onGetAutogeneratedTopics () {
        return axios.get(this.state.apiUrl + '/autogeneratedtopics')
          .then((results) => {
              this.setState({autogeneratedTopics: results.data});
          });
    }
    onGetAutogeneratedByTitle (title) {
        return axios.get(this.state.apiUrl + '/autogeneratedtopics?conditions{"title":"' + title + '"}')
        .then((results) => {
            if (!results.data) {
                return history.push('/');
            }
            let data = results.data[0];
            let options = data.options.map((option) => {
                return {position: option.position, sentence: ''};
            });
            this.setState({
                currentTopic: data,
                title: data.title,
                options: options,
                creatorOptions: Utilities.completeOptions(data.options),
                comments: []
            });
            AppActions.getRelatedTopics({topicTitle: data.title});
            AppActions.getGlobalComments(data.global_title);
        });
    }
    onGetRelatedTopics (data) {
        let limit = data.limit || 4;
        return axios.get(this.state.apiUrl + '/usertopics?sort=-comments&conditions={"title":"' + data.topicTitle + '","createdBy":{"$ne":null}}&populate=createdBy&select=-options&limit=' + limit)
      .then((results) => {
          this.setState({relatedTopics: results.data});
          if (data.globalTopic) {
              this.state.relatedTopics.push(data.globalTopic);
          }
      });
    }
    onCreateTopic (newTopic) {
        this.setState({uploadingTopic: true});
        let hash = window.localStorage.getItem('creator');
        newTopic.creatorHash = hash;
        return axios.post(this.state.apiUrl + '/usertopics', newTopic)
          .then((response) => {
              this.setState({enableEditing: false, uploadingTopic: false});
              history.push(`/topic/` + Utilities.getHumanUrl(response.data));
          })
          .catch((err) => {
              console.error(err);
              this.setState({uploadingTopic: false});
          });
    }
    onDisableEdition () {
        this.setState({enableEditing: false});
    }
    onEnableEdition () {
        this.setState({enableEditing: true});
    }
    onGetTopicById (topicId, topic) {
        this.setState({loadingOptions: true});
        return axios.get(this.state.apiUrl + '/usertopics/?conditions={"id":"' + topicId + '"}&populate=createdBy')
          .then((results) => {
              if (results.data.length !== 1) {
                  return history.push('/notfound');
              }
              let data = results.data[0];
              let options = data.options.map((option) => {
                  return {position: option.position, sentence: ''};
              });
              let profileImage = data.createdBy ? data.createdBy.profile_image : '../images/icons/default.jpg';

              this.setState({
                  currentTopic: data,
                  topicLikedByUser: data.likedByUser,
                  topicDislikedByUser: data.dislikedByUser,
                  topicLikes: data.likesCount,
                  globalTopic: false,
                  topicDislikes: data.dislikesCount,
                  currentTopicCreatorImage: profileImage.sizeSmall,
                  title: data.title,
                  options: options,
                  creatorOptions: Utilities.completeOptions(data.options),
                  comments: [],
                  loadingOptions: false});

              AppActions.getRelatedTopics({topicTitle: data.title});
              AppActions.getPopularSentencesByTitle(data.title, 8, data._id);
              AppActions.getComments(data._id);
              AppActions.getTopicActivity(data.title);
              AppActions.getTopicSuggestions(data.title);
              AppActions.getIsTopicInList(data.title, 'favorites');
              AppActions.getIsSameTopicByMe(data.global_title);

              if (topic !== Utilities.getTopicTitle(data)) {
                  history.push('/topic/' + Utilities.getHumanUrl(data));
              }
          })
          .catch((error) => {
              console.error('getTopicError: ' + error + JSON.stringify(error));
              history.push('/');
          });
    }
    onGetGlobal (topicTitle) {
        return axios.get(this.state.apiUrl + '/globaltopics/fromtopic/' + topicTitle)
      .then((results) => {
          if (!results.data) {
              return history.push('/');
          }
          let data = results.data;
          let options = data.options.map((option) => {
              return {position: option.position, sentence: ''};
          });
          this.setState({
              currentTopic: data,
              title: data.title,
              globalTopic: data.title,
              options: options,
              creatorOptions: Utilities.completeOptions(data.options),
              comments: []
          });
          AppActions.getRelatedTopics({topicTitle: data.title, globalTopic: this.state.currentTopic});
          AppActions.getGlobalComments(data.global_title);
          AppActions.getIsSameTopicByMe(data.global_title);
          AppActions.getTopicActivity(data.title);
          AppActions.getIsTopicInList(data.title, 'favorites');
          AppActions.getTopicSuggestions(data.title);
          if (topicTitle !== data.title) {
              history.push('/topic/g_' + data._title);
          }
      })
      .catch((error) => {
          console.error('getGlobalError: ' + error + JSON.stringify(error));
          history.push('/');
      });
    }
    onGetRandomSentences () {
        return axios.get(this.state.apiUrl + '/sentences?limit=7&sort=-createdAt')
      .then((results) => {
          let randomOrder = results.data.sort(function () {
              return 0.5 - Math.random();
          });
          return this.setState({randomSentences: randomOrder});
      });
    }
    onGetPopularSentencesByTitle (title, limit, topicIdExcepted) {
        let queryString = 'title=' + title;
        if (limit) {
            queryString += '&limit=' + limit;
        }
        if (topicIdExcepted) {
            queryString += '&topicIdExcepted=' + topicIdExcepted;
        }
        return axios.get(this.state.apiUrl + '/popularoptions?' + queryString)
        .then((results) => {
            this.setState({
                otherOptions: results.data,
                otherOptionsCopy: results.data
            });
        })
        .catch((error) => {
            console.error('getPopularSentencesByTitleError: ' + error + JSON.stringify(error));
            history.push('/');
        });
    }
    onCleanOptions () {
        this.setState({
            title: '',
            options: [{position: 1}, {position: 2}, {position: 3}, {position: 4}, {position: 5}]
        });
    }
    onCleanComments () {
        this.setState({comments: [], comment: ''});
    }
    onCleanTopic () {
        this.setState({
            currentTopic: {
                options: []
            },
            creatorOptions: [],
            title: '',
            comments: [],
            comment: '',
            options: [{position: 1}, {position: 2}, {position: 3}, {position: 4}, {position: 5}],
            relatedTopics: []
        });
        SearchActions.cleanSearch();
    }
    onNewTopicStart () {
        this.setState({topicCreated: false});
    }
    onLoginUserFacebook (userFacebook) {
        this.setState({loadingLogin: true});
        return axios.post(this.state.apiUrl + '/user/loginFacebook', userFacebook)
          .then((datauserLogged) => {
              if (datauserLogged.data.result !== 'fail') {
                  datauserLogged.data.user.logged = true;
                  window.localStorage.setItem('user', JSON.stringify(datauserLogged.data.user));
                  window.localStorage.setItem('creator', JSON.stringify(datauserLogged.data.user.creatorHash));
                  axios.defaults.headers.common['Authorization'] = ' Bearer ' + datauserLogged.data.user.token;
                  let parts = datauserLogged.data.user.token.split('.');
                  let decodedToken = JSON.parse(base64.decode(parts[1]));
                  this.setState({
                      userLogged: datauserLogged.data.user.logged,
                      userData: datauserLogged.data.user,
                      user: decodedToken,
                      loadingLogin: false
                  });
                  ModalActions.changeModalLoginStatus(false);
              }
          })
          .catch((err) => {
              this.setState({loadingLogin: false});
              console.error('Error in google login: ', err);
          });
    }
    onLoginUserGoogle (userGoogle) {
        this.setState({loadingLogin: true});
        return axios.post(this.state.apiUrl + '/user/loginGoogle', userGoogle)
          .then((datauserLogged) => {
              if (datauserLogged.data.result !== 'fail') {
                  datauserLogged.data.user.logged = true;
                  window.localStorage.setItem('user', JSON.stringify(datauserLogged.data.user));
                  window.localStorage.setItem('creator', JSON.stringify(datauserLogged.data.user.creatorHash));
                  axios.defaults.headers.common['Authorization'] = ' Bearer ' + datauserLogged.data.user.token;
                  let parts = datauserLogged.data.user.token.split('.');
                  let decodedToken = JSON.parse(base64.decode(parts[1]));
                  this.setState({
                      userLogged: datauserLogged.data.user.logged,
                      userData: datauserLogged.data.user,
                      user: decodedToken,
                      loadingLogin: false
                  });
                  ModalActions.changeModalLoginStatus(false);
              }
          })
          .catch((err) => {
              this.setState({loadingLogin: false});
              console.error('Error in google login: ', err);
          });
    }
    onUpdateUserProfile () {
        let userData = this.state.userData;
        let username = userData.username;
        return axios.get(`${this.state.apiUrl}/users?conditions={"username":"${username}"}`)
        .then((response) => {
            const data = response.data[0];
            userData.username = data.username;
            userData.email = data.email;
            userData.profile_image = data.profile_image;
            userData.name = data.name;
            userData.user = data.user;
            userData.followers = data.followers;
            userData.following = data.following;
            window.localStorage.setItem('user', JSON.stringify(userData));
            this.setState({userData: userData});
        });
    }
    onLogout () {
        this.setState({
            userLogged: false,
            userData: {profile_image: {}},
            user: {}
        });
        window.localStorage.removeItem('user');
        window.localStorage.removeItem('creator');
    }
    onGetComments (topicId) {
        this.setState({comments: [], loadingComments: true});
        return axios.get(this.state.apiUrl + '/comments?sort=-createdAt&populate=[{"path":"responses","options":{"populate":"createdBy"}},{"path":"createdBy"}]&conditions={"usertopic":"' + topicId + '","responseTo":null}&limit=' + (this.state.commentsLimit + 1))
      .then((results) => {
          if (results.data.length > this.state.commentsLimit) {
              this.setState({loadMoreComments: true});
          }
          return this.setState({comments: results.data.slice(0, this.state.commentsLimit), loadingComments: false});
      });
    }
    onGetMoreComments (topicId) {
        return axios.get(this.state.apiUrl + '/comments?sort=-createdAt&populate=[{"path":"responses","options":{"populate":"createdBy"}},{"path":"createdBy"}]&conditions={"usertopic":"' + topicId + '","responseTo":null}&limit=' + (this.state.commentsLimit + 1) + '&skip=' + this.state.comments.length)
      .then((results) => {
          let dataLength = results.data.length;
          if (this.state.commentsLimit < results.data.length) {
              this.setState({loadMoreComments: true});
              dataLength = dataLength - 1;
          } else {
              this.setState({loadMoreComments: false});
          }
          return this.setState({comments: this.state.comments.concat(results.data).slice(0, dataLength + this.state.comments.length)});
      });
    }
    onGetGlobalComments (globalTitle) {
        this.setState({comments: []});
        return axios.get(this.state.apiUrl + '/comments?sort=-createdAt&populate=[{"path":"responses","options":{"populate":"createdBy"}},{"path":"createdBy"}]&conditions={"topic":"' + globalTitle + '","responseTo":null}')
      .then((results) => {
          return this.setState({comments: results.data});
      });
    }
    onNewComment (newComment) {
        if (!this.state.userLogged) {
            return ModalActions.changeModalLoginStatus(true);
        }
        return axios.post(this.state.apiUrl + '/comments', newComment)
          .then((results) => {
              let comments = this.state.comments;
              results.data.createdBy = this.state.userData;
              comments.unshift(results.data);
              return this.setState({comments: comments, comment: ''});
          });
    }
    onNewCommentResponse (newComment) {
        if (!this.state.userLogged) {
            return ModalActions.changeModalLoginStatus(true);
        }
        return axios.post(this.state.apiUrl + '/comments/response/' + newComment.responseTo, newComment)
        .then((results) => {
            let comments = this.state.comments;
            let currentComment = comments.find((comment) => {
                return comment._id === newComment.responseTo;
            });
            results.data.createdBy = this.state.userData;
            currentComment.responses.push(results.data);
            return this.setState({comments: comments});
        });
    }
    onVoteComment (comment, vote) {
        if (!this.state.userLogged) {
            return ModalActions.changeModalLoginStatus(true);
        }
        return axios.post(this.state.apiUrl + '/vote/comment/' + comment._id + '/' + vote, {})
      .catch((errors) => {
          console.error('error' + JSON.stringify(errors));
      });
    }
    onSugestTranslate (dataTranslate) {
        return axios.post(this.state.apiUrl + '/translate/sugestTranslate', dataTranslate)
        .catch((errors) => {
            console.error('error' + JSON.stringify(errors));
        });
    }
    onGetTopicSuggestions (topicTitle) {
        this.setState({loadingTopicInformation: true});
        return axios.get(this.state.apiUrl + '/globaltopics/suggestions/' + topicTitle + '?limit=5')
        .then((results) => {
            this.setState({topicSuggestions: results.data, loadingTopicInformation: false});
        });
    }
    onLikeTopic (like) {
        if (!this.state.userLogged) {
            return ModalActions.changeModalLoginStatus(true);
        }
        return axios.post(this.state.apiUrl + '/vote/like/userTopic/', like)
        .catch((errors) => {
            console.error('error' + JSON.stringify(errors));
        });
    }

    onGetTopicActivity (topicTitle) {
        return axios.get(this.state.apiUrl + '/topics/activity/' + topicTitle)
        .then((results) => {
            this.setState({topicActivity: {
                creations: results.data.creations,
                relatedOptions: results.data.relatedOptions
            }});
        });
    }

    onGetTopicLists () {
        return axios.get(this.state.apiUrl + '/topiclists/')
        .then((results) => {
            console.warn(results);
        });
    }

    onGetIsTopicInList (topicname, listname) {
        return axios.get(this.state.apiUrl + '/lists/isTopicInList/' + listname + '?topicName=' + topicname)
        .then((results) => {
            this.setState({isTopicFaved: results.data.topicInList, cantFavs: results.data.count});
        });
    }

    onAddToTopicListByName (globalTitleRef, listname) {
        if (!this.state.userLogged) {
            return ModalActions.changeModalLoginStatus(true);
        }

        let body = {
            topicName: globalTitleRef,
            name: listname
        };
        return axios.post(this.state.apiUrl + '/topiclists', body)
        .then((response) => {
            this.setState({isTopicFaved: true, cantFavs: this.state.cantFavs + 1});
        })
        .catch((error) => {
            console.warn(error);
        });
    }

    onAddToTopicListById (globalTitleRef, listname) {
        if (!this.state.userLogged) {
            return ModalActions.changeModalLoginStatus(true);
        }

        let body = {
            topicId: globalTitleRef,
            name: listname
        };
        return axios.post(this.state.apiUrl + '/topiclists', body)
        .then((response) => {
            this.setState({isTopicFaved: true, cantFavs: this.state.cantFavs + 1});
        })
        .catch((error) => {
            console.warn(error);
        });
    }

    onRemoveTopicFromListById (topicRef, name) {
        return axios.delete(this.state.apiUrl + '/lists/removeFromList/' + name + '?queryByName=false&&topicId=' + topicRef)
        .then((response) => {
            this.setState({isTopicFaved: false, cantFavs: this.state.cantFavs - 1});
        })
        .catch((error) => {
            console.warn(error);
        });
    }
    onRemoveTopicFromListByName (topicRef, name) {
        return axios.delete(this.state.apiUrl + '/lists/removeFromList/' + name + '?queryByName=true&&topicName=' + topicRef)
        .then((response) => {
            this.setState({isTopicFaved: false, cantFavs: this.state.cantFavs - 1});
        })
        .catch((error) => {
            console.warn(error);
        });
    }
    onFocusOptionIndex (index) {
        this.setState({optionIndex: index});
    }
    onSelectOption (sentence) {
        let options = this.state.options;
        let creatorOptions = this.state.creatorOptions;
        options[this.state.optionIndex].sentence = sentence;
        creatorOptions[this.state.optionIndex].sentence = sentence;
        this.setState({
            options,
            creatorOptions
        });
    }
    onCleanOptionsAutocomplete () {
        this.setState({
            otherOptions: this.state.otherOptionsCopy
        });
    }

    onFollowUser (userToFollowId) {
        if (!this.state.userLogged) {
            return ModalActions.changeModalLoginStatus(true);
        }
        return axios.post(this.state.apiUrl + '/user/followUser', {
            userToFollowId: userToFollowId
        })
          .then((response) => {
              this.onUpdateUserProfile();
          })
          .catch((err) => {
              console.error(err);
          });
    }

    onUnfollowUser (userToUnfollowId) {
        if (!this.state.userLogged) {
            return ModalActions.changeModalLoginStatus(true);
        }
        return axios.post(this.state.apiUrl + '/user/unfollowUser', {
            userToUnfollowId: userToUnfollowId
        })
          .then((response) => {
              this.onUpdateUserProfile();
          })
          .catch((err) => {
              console.error(err);
          });
    }
    onSearchOption (query) {
        axios.get(this.state.apiUrl + '/autocomplete/option/' + query + '/' + this.state.topic)
          .then((response) => {
              let otherOptions = Array.from(
                new Set(response.data.concat(this.state.otherOptionsCopy))
              );
              this.setState({
                  otherOptions
              });
          });
    }

    onGetIsSameTopicByMe (globalTitle) {
        axios.get(this.state.apiUrl + '/topics/isSameTopicByMe/' + globalTitle)
          .then((response) => {
              this.setState({isSameTopicByMe: response.data.exists, sameTopicByMe: response.data.topicCreatedByMe});
          });
    }

    onGetPopularUsers () {
        axios.get(this.state.apiUrl + '/users?sort="-followers"&limit=4')
          .then((response) => {
              this.setState({popularUsers: response.data});
          });
    }

    onGetFollowedTopics () {
        const skip = this.state.followedTopics ? this.state.followedTopics.length : 0;
        axios.get(this.state.apiUrl + '/topics/followedTopics?limit=' + this.state.pageLimit + '&skip=' + skip)
          .then((response) => {
              this.setState({followedTopics: this.state.followedTopics.concat(response.data)});
          });
    }

    onGetUnreadedNotifications () {
        if (this.state.userLogged && this.state.user._id) {
            return axios.get(this.state.apiUrl + '/notifications?limit=10&select=title readed&conditions{to: "' + this.state.user._id + '"}&sort=-createdAt')
              .then((results) => {
                  let unreadedNotifs = results.data.filter((notif) => {
                      return !notif.readed;
                  });
                  this.setState({unreadedNotifications: unreadedNotifs});
              });
        }
        return null;
    }

    onUpdateUsername (username) {
        let updatedUserData = this.state.userData;
        updatedUserData.username = username;
        this.setState({userData: updatedUserData});
        this.onUpdateUserProfile();
    }

    onVerifyCreatorHash () {
        let hash = window.localStorage.getItem('creator');
        if (!hash) {
            return this.getHash();
        }
    }

    getHash () {
        return axios.get(this.state.apiUrl + '/user/hash')
            .then((response) => {
                if (response.data.creatorHash) {
                    window.localStorage.setItem('creator', JSON.stringify(response.data.creatorHash));
                }
            });
    }
    onShowSocial (e) {
        e.preventDefault();
        this.setState({
            socialClass: (this.state.socialClass
                ? ''
                : 'showItem')
        });
    }
}



// WEBPACK FOOTER //
// ./src/AppStore.js